module.exports = __webpack_public_path__ + "static/media/po-reman-4.03842812.png";